import React from "react";
import "./footer.css";

function Footer() {
  const handleclick = () => {
    window.open("https://netseed.co", "_blank");
  };
  return (
    <div>
      <div className="border-top footer ps-3">
        <span>
          <p className="mt-3">
            <span className="fw-bold">
              Copyright © 2020-2025
              <span
                className="footer-hover ms-1 me-1"
                style={{ color: "#007aff", fontWeight: "bold" }}
                onClick={handleclick}
              >
                NetSeed.co
              </span>{" "}
            </span>{" "}
            All rights reserved.
          </p>
        </span>
      </div>
    </div>
  );
}

export default Footer;
